function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Brand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.933 6.132l-.56.855c-.38-.345-1.25-.987-2.701-.987-1.678 0-3.684 1.036-3.684 3.125s1.383 2.896 2.73 3.389l1.053.378c1.086.394 2.171.838 2.171 2.204 0 1.152-.887 1.794-2.023 1.794h-.115c-1.003 0-2.122-.74-2.698-2.056l-.443-.97h-.808v3.996h.692l.625-.987c.477.51 1.447 1.119 2.814 1.119 2.187 0 4.014-1.284 4.014-3.422 0-2.122-1.267-2.863-2.945-3.472l-1.07-.394a44.36 44.36 0 00-.145-.053c-1.03-.371-1.976-.712-1.976-1.97 0-1.135.955-1.595 1.876-1.595h.132c1.25 0 2.074.821 2.634 2.074l.427.97h.642V6.132h-.642zm-8.407 5.61c0 4.243-2.978 6.12-5.839 6.12H2v-.838c.89-.066 1.218-.444 1.218-1.81V8.65c0-1.366-.328-1.562-1.218-1.612v-.904h4.687c2.927-.002 5.84 1.478 5.84 5.608zm-2.32.64v-.904c0-3.028-1.826-4.36-3.717-4.36H5.337v9.739H6.49c1.957 0 3.717-1.58 3.717-4.475z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Brand);
export default ForwardRef;